import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const cmsGridBlockEntity: Entity = {
  model: model,
  repository: repository,
}

export default cmsGridBlockEntity
